if(!customElements.get('scroll-observer')) {
  class ScrollObserver extends HTMLElement {
    constructor() {
      super();

      this.elObserve = this.querySelector('[data-observe]');
      this.observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          const { boundingClientRect, rootBounds, isIntersecting } = entry;
          const hasPassed = !isIntersecting && boundingClientRect.y < rootBounds.height;

          this.classList.toggle('scroll-intersecting', isIntersecting)
          this.classList.toggle('scroll-passed', hasPassed);
        });
      });

      this.observer.observe(this.elObserve);
    }
  }

  customElements.define('scroll-observer', ScrollObserver);
}